export default __webpack_public_path__ + "static/cruiselines-royal-ship-6-92dcda2ba8784de61dddbc2d24a55029.jpg";